import { render, staticRenderFns } from "./HomeComponent.vue?vue&type=template&id=2740fd67&scoped=true&"
import script from "./HomeComponent.vue?vue&type=script&lang=js&"
export * from "./HomeComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomeComponent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HomeComponent.vue?vue&type=style&index=1&id=2740fd67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2740fd67",
  null
  
)

export default component.exports